import { Badge } from '@chakra-ui/react';
import { getAlertsSummaryApi } from 'api/alertApi';
import { useEffect, useState } from 'react';

const AlertsBadge = () => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    const fetchCount = async () => {
      try {
        const data = await getAlertsSummaryApi();
        setCount(data.pendingCount || 0);
      } catch {
        // silently fail
      }
    };

    fetchCount();
    const interval = setInterval(fetchCount, 60000);
    return () => clearInterval(interval);
  }, []);

  if (count === 0) return null;

  return (
    <Badge
      colorScheme="red"
      borderRadius="full"
      px="6px"
      py="1px"
      fontSize="10px"
      ml="auto"
    >
      {count}
    </Badge>
  );
};

export default AlertsBadge;
